import { Directive } from '@angular/core';

@Directive({
  selector: '[tagTemplate]',
  standalone: true,
})
export class TagTemplateDirective {}
